export default __webpack_public_path__ + "static/media/noun-round-trip-936561.d173dc8f.svg";